import { BsDatabaseDash } from "react-icons/bs";

const EmptyData = () => {
  return (
    <div className="flex flex-col justify-center items-center w-full h-full text-center text-gray-500">
      <BsDatabaseDash size={48} />
      <p className="mt-4 text-lg">No data available</p>
    </div>
  );
};

export default EmptyData;
